export default __webpack_public_path__ + "static/media/dashboard.fd19382e.png";